<template>
  <!-- prettier-ignore -->
  <div>
    <search-condition searchable :loading="searching" @do-search="search">
      <ns-company v-model="condition.companyId" />
      <n-field-id v-model="condition.customerId" label="customerId" />
      <n-field-id v-model="condition.accountId" label="accountId" />
      <n-field-enum v-model="condition.type" enum-name="TransactionType" label="type" all-option />
      <n-field-enum v-model="condition.status" enum-name="IssueStatus" label="status" all-option />
      <n-field-datetime v-model="condition.from" label="from" />
      <n-field-datetime v-model="condition.to" label="to" />
    </search-condition>
    <n-table :total="total" :page-no="pageNo" :page-size="pageSize" :searched="searched" :searching="searching" :has-result="hasResult" @on-page-no="onPageNo" @on-page-size="onPageSize">
      <customer-transaction-table :records="records" is-active></customer-transaction-table>
    </n-table>
  </div>
</template>

<script>
import CustomerView from './view';
import PaginateMixin from '@/mixins/paginate-mixin';
import CustomerTransactionTable from './CustomerCustomerTransactionTable';
import { fetch } from '@/api/customer/customer-customer-transaction';
import { Parser, setCurrencyScale } from '@/helpers/operators';
import {CURRENCY_SCALE_NAME} from "@/constant/enums";

export default CustomerView.extend({
  name: 'CustomerCustomerTransactionActive',
  components: { CustomerTransactionTable },
  mixins: [PaginateMixin],
  props: {
    condition: Object,
  },
  methods: {
    doSearch(params) {
      let p = { ...params, ...this.condition };
      return fetch(p);
    },
    parse(data) {
      this.records = Parser( data.records, [setCurrencyScale(CURRENCY_SCALE_NAME.CURRENCY)]);
      this.$emit('records', this.records);
    },
  },
});
</script>
